<template>
	<div class="my_push" v-loading="element_loading" element-loading-text="拼命加载中......"
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
		<!-- 动态按钮生成 -->
		<div class="title">
			<div id="notice">
				<h5>业务表初始化使用说明:<br>
					<span>1、初步建立业务表逻辑:控制逻辑和存储结构。</span><br>
					<span>2、默认支持查询,配置方式:<span class="red">base+'下划线'+唯一标识</span>,如:base_tab_build</span><br>
					<span>3、默认支持编辑,配置方式:<span
							class="red">base+'下划线'+唯一标识</span>,如:base_tab_build。自定义方法为exp15、exp30、exp50</span><br>
					<span>4、除上述情景外,不具备普遍性的<span class="red">查询|编辑</span>需要单独写相应方法,比如查询另一个表的相关明细内容。</span><br>
					<span class="red">5、如果业务标识不为空,建表时自动添加字段 sheet_no 。</span><br>
					<span class="red">6、查询参数最多10个,布局行数最大10行。超出不起作用</span><br>
					<span class="red">7、取消建表和字段生成功能，专门用于前端布局设置。</span><br>
					<span style="font-weight: bold;color: #ff0000;">8、只对简单结构数据表进行业务表配置,以便于扩展。</span><br>
				</h5>
			</div>
		</div>

		<div class="content_edit">
			<div class="content_edit_item ">
				<div class="content_edit_item  ">
					<label>主表名称:</label><input class="pre-input" type="text" v-model="sel_tab_name" />
				</div>
				<div class="content_edit_item  ">
					<label>业务名称:</label><input class="pre-input" type="text" v-model="sel_menu_name"
						readonly="readonly" />
				</div>
				<div class="content_edit_item  ">
					<label>子业务名称:</label><input class="pre-input" type="text" v-model="sel_menu_name_d"
						readonly="readonly" />
				</div>
				<div class="content_edit_item tab-item-btn ">
					<button class="pre_btn_ok" @click="fun_load_first()">查询</button>
					<button class="pre_btn_ok" @click="fun_show_power">发布到权限管理</button>
					<button @click="look_note">备注说明</button>
				</div>
			</div>
		</div>

		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="主表建设" name="first"></el-tab-pane>
			<el-tab-pane label="主表结构编辑" name="second"></el-tab-pane>
			<!-- <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane> -->
		</el-tabs>
		<div class="edit-main-tab" v-show="show_push_1">
			<!-- 展示 已经建立主表和子表 -->
			<!-- 当点击时 显示对应数据结构 -->
			<!-- 如果有子表,则显示。同时点击则显示对应表结构 -->
			<div class="push-1-left">
				<div class="title">
					<h5>主业务表</h5>
				</div>

				<div>
					<table class="dataintable tab-inline" border="1" cellpadding="2" cellspacing="1">
						<thead>
							<tr>
								<th>序号</th>
								<th class="long1_2">数据表名</th>
								<th class="long1_2">业务名称</th>
								<th class="long1">跳转参数</th>
								<th class="short-word-3">状态</th>
							</tr>
						</thead>
						<tbody class="tab_body">
							<tr :id="'m_'+item.id" v-for="(item, index) in list_tab_main" :key="index"
								@click="sel_row_main(item,'m_')">
								<td>{{ back_row_num(index) }}</td>
								<td class="long1_2">{{ item.tab_name }}</td>
								<td class="long1_2">{{ item.menu_name }}</td>
								<td class="long1">{{ item.menu_value }}</td>
								<td class="short-word-3 cen">{{ item.flag }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- 分页部分 -->
				<div class="pre_page">
					<ul style="text-align: right; margin-right: 2px;">
						<li style="line-height: 24px;height: 24px;padding: 2px 6px;">
							<span>分页:
								<input class="short-word-1" style="line-height: 24px;height: 24px;" type="text"
									v-model="page_length" @change="fun_load_first()" /></span>
							当前页:<label>{{ nowpage }}</label>&nbsp; 合计页：<label>{{ maxpage }}</label>&nbsp;&nbsp;
							<a href="#" @click="beforepage">上一页</a>|
							<a href="#" @click="nextpage">下一页</a>
							<input class="short-word-1" style="line-height: 24px;height: 24px;" type="text"
								v-model="jumppage" value="" /><a href="#" @click="gopage" class="go">Go</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="push-1-right">
				<div class="title">
					<span>编辑</span>
					<span v-show="show_title">ID:{{row_id}}</span><span v-show="show_title">编辑人:{{u_name}}</span><span
						v-show="show_title">更新时间:{{sys_date}}</span>
				</div>
				<div class="content_edit tab-build-edit">
					<div class="  tab-build">
						<div class="content_edit_item  ">
							<label>数据表名:</label><input class="pre-input" type="text" v-model="tab_name"
								placeholder="必填" />
						</div>
						<div class="content_edit_item  ">
							<label>业务名称:</label><input class="pre-input" type="text" v-model="menu_name"
								placeholder="必填" />
						</div>
						<div class="content_edit_item  ">
							<label>跳转参数:</label><input class="pre-input" type="text" v-model="menu_value"
								placeholder="必填" />
						</div>
					</div>
					<div class="  tab-build">
						<div class="content_edit_item  ">
							<label>业务标识:</label><input class="pre-input" type="text" v-model="sheet_val"
								placeholder="非单据类型表可不填" />
						</div>
						<div class="content_edit_item  ">
							<label>父级表名:</label><input class="pre-input" type="text" v-model="sub_sheet_val"
								placeholder="没有父级业务可不填" />
						</div>
					</div>
					<div class="  tab-build">
						<div class="content_edit_item  ">
							<label>查询方法:</label><input class="pre-input" type="text" v-model="sel_action"
								placeholder="必填" />
						</div>
						<div class="content_edit_item  ">
							<label>编辑方法:</label><input class="pre-input" type="text" v-model="upd_action"
								placeholder="必填" />
						</div>
					</div>
					<div class="  tab-build">
						<div class="content_edit_item  ">
							<label>前置业务:</label>
							<el-radio v-model="edit_before" label="0">否</el-radio>
							<el-radio v-model="edit_before" label="1">是</el-radio>

						</div>
					</div>
					<div class="  tab-build">
						<div class="content_edit_item  ">
							<label>后置业务:</label>
							<el-radio v-model="edit_end" label="0">否</el-radio>
							<el-radio v-model="edit_end" label="1">是</el-radio>

						</div>
					</div>
					<div class="  tab-build">
						<div class="content_edit_item  ">
							<label>附件方法:</label><input class="pre-input" type="text" v-model="file_action"
								placeholder="无附件可不填" />
						</div>
						<div class="content_edit_item  ">
							<label>一级路径:</label><input type="text" class="pre-input short0" v-model="path1"
								placeholder="同附件方法" />
						</div>
						<div class="content_edit_item  ">
							<label>二级路径:</label><input type="text" class="pre-input short0" v-model="path2"
								placeholder="同附件方法" />
						</div>
						<div class="content_edit_item  ">
							<label>三级路径:</label><input type="text" class="pre-input short0" v-model="path3"
								placeholder="同附件方法" />
						</div>
					</div>
					<div class="  tab-build">
						<div class="content_edit_item  ">
							<label>备注:</label>
							<el-input type="textarea" autosize class="td-build-textarea" placeholder="一些说明..."
								v-model="note">
							</el-input>
						</div>
					</div>
				</div>
				<div class="content_edit">
					<div class="content_edit_item">
						<button class="pre_btn_ok" @click="fun_load_first()">刷新</button>
						<button class="pre_btn_ok" @click="fun_build_save('_add','1')">保存</button>
						<button class="pre_btn_ok" @click="fun_build_save('_del','1')">删除</button>
					</div>
				</div>
			</div>
		</div>
		<div v-show="show_push_2">
			<!-- 显示选择表对应的所有表结构 操作控制 -->
			<div class="push-2-left">
				<div class="title">
					<h5>主表结构</h5>
				</div>

				<div>
					<table class="dataintable tab-inline" border="1" cellpadding="2" cellspacing="1">
						<thead>
							<tr>
								<th>序号</th>
								<th class="long1">结构名称</th>
								<th class="long1">显示名称</th>
								<th class="short-word-3">类型</th>
								<th class="short-word-2">查询</th>
								<th class="short-word-2">编辑</th>
								<th class="short-word-2">必填</th>
								<th class="short-word-2">只读</th>
								<th class="short-word-2">重复</th>
								<th class="short-word-2">显排</th>
								<th class="short-word-2">布排</th>
								<!-- <th class="short-word-3">修改人</th> -->
								<!-- <th class="short0">更新时间</th> -->
							</tr>
						</thead>
						<tbody class="tab_body">
							<tr :id="'m_c_'+item.id" v-for="(item, index) in list_tab_main_col" :key="index"
								@click="sel_row_main_col(item,'m_c_')">
								<td>{{ back_row_num(index) }}</td>
								<td class="long1">{{ item.tb_name }}</td>
								<td class="long1 ">{{ item.td_name }}</td>
								<td class="short-word-3 col-type"><a
										href="#">{{ item.col_type }}<span>{{ item.col_type }}</span></a>
								</td>
								<td class="short-word-2 cen">{{ back_yes_no(item.td_sel) }}</td>
								<td class="short-word-2 cen">{{ back_yes_no(item.td_pass) }}</td>
								<td class="short-word-2 cen">{{ back_yes_no(item.td_weight) }}</td>
								<td class="short-word-2 cen">{{ back_yes_no(item.td_readonly) }}</td>
								<td class="short-word-2 cen">{{ back_yes_no(item.td_repeat) }}</td>
								<td class="short-word-2 cen">{{ item.td_step }}</td>
								<td class="short-word-2 cen">{{ item.td_x }}</td>
								<!-- <td class="short-word-3 cen">{{ item.u_name }}</td> -->
								<!-- <td class="short0 cen">{{ back_date(item.sys_date) }}</td> -->
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="push-2-right">
				<div class="title">
					<span>编辑</span>
					<span v-show="show_title_d">ID:{{row_id_d}}</span>
					<span v-show="show_title_d">编辑人:{{u_name_d}}</span>
					<span v-show="show_title_d">更新时间:{{sys_date_d}}</span>
				</div>
				<div class="content_edit">
					<div class="content_edit_item  tab-build">
						<div class="content_edit_item  ">
							<label>结构名称:</label><input class="pre-input" type="text" v-model="tb_name"
								placeholder="必填" />
						</div>
						<div class="content_edit_item  ">
							<label>显示名称:</label><input class="pre-input" type="text" v-model="td_name"
								placeholder="必填" />
						</div>
					</div>
					<div class="content_edit_item  tab-build">
						<div class="content_edit_item  ">
							<label>字段类型:
							</label><input type="text" class="pre-input" v-model="td_type" placeholder="必填" />
							<pre-sel-one class="pre-input long1" @selectFunc="fun_list_sel($event)"
								v-bind:searchList="list_col" :selectValue="sel_col_val" />
						</div>
					</div>
					<div class="content_edit_item  tab-build">
						<div class="content_edit_item  ">
							<label>查询标识:</label>
							<input type="text" class="pre-input" v-model="td_sel_action" placeholder="对应查询方法" />
						</div>
						<div class="content_edit_item  ">
							<span class="red">有多选项的查询集合需要写入对应存储过程</span>
						</div>
					</div>
					<div class="content_edit_item  tab-build">
						<div class="content_edit_item  ">
							<label>字段默认:</label><input class="pre-input" type="text" v-model="td_default"
								placeholder="字段默认值" />
						</div>
					</div>
					<div class="content_edit_item  tab-build">
						<div class="content_edit_item  ">
							<label>字段样式:</label><input class="pre-input" type="text" v-model="td_class"
								placeholder="预制好才有效" />
						</div>
					</div>
					<div class="content-edit-row">
						<label>是否查询:</label>
						<el-radio v-model="td_sel" label="0">否</el-radio>
						<el-radio v-model="td_sel" label="1">是</el-radio>
					</div>
					<div class="content-edit-row">
						<label>是否编辑:</label>
						<el-radio v-model="td_pass" label="0">否</el-radio>
						<el-radio v-model="td_pass" label="1">是</el-radio>
					</div>
					<div class="content-edit-row">
						<label>是否必填:</label>
						<el-radio v-model="td_weight" label="0">否</el-radio>
						<el-radio v-model="td_weight" label="1">是</el-radio>
					</div>
					<div class="content-edit-row">
						<label>是否只读:</label>
						<el-radio v-model="td_readonly" label="0">否</el-radio>
						<el-radio v-model="td_readonly" label="1">是</el-radio>
					</div>
					<div class="content-edit-row">
						<label>是否重复:</label>
						<el-radio v-model="td_repeat" label="0">否</el-radio>
						<el-radio v-model="td_repeat" label="1">是</el-radio>
					</div>
					<div class="content-edit-row">
						<div class="content_edit_item  ">
							<label>显示排序:</label><input class="pre-input short-word-2" type="number" v-model="td_step"
								placeholder="" />
						</div>
						<div class="content_edit_item  ">
							<label>布局排序:</label><input class="pre-input short-word-2" type="number" v-model="td_x"
								placeholder="" />
						</div>
					</div>
				</div>
				<div class="content_edit">
					<div class="content_edit_item">
						<button class="pre_btn_ok" @click="fun_load_second()">刷新</button>
						<button class="pre_btn_ok" @click="fun_col_save('_add','1')">保存</button>
						<button class="pre_btn_ok" @click="fun_col_save('_del','1')">删除</button>
					</div>
				</div>
			</div>
		</div>
		<div v-show="show_push_3">
			待定3
		</div>

		<div v-show="show_push_4">
			待定4
		</div>

		<div v-show="show_power" class="pre_tan">
			<span class="pre_tan_bg"></span>
			<!-- <span class="pre_tan_bg" @click="closeshow"></span> -->
			<div class="pre_tan_conten">
				<span class="pre_tan_close">
					<img src="../../assets/image/shan1.png" @click="closeshow" />
				</span>
				<div class="pre_upload">

					<div class="content_edit">
						<div class="content_edit_item  tab-build">
							<div class="content_edit_item  ">
								<label>业务名称:</label><input class="pre-input" type="text" v-model="sel_menu_name"
									readonly="readonly" />
							</div>
						</div>
						<div class="content_edit_item  tab-build">
							<div class="content_edit_item  ">
								<label>父级菜单:
								</label><input type="text" class="pre-input" v-model="sel_one_name" placeholder="必填" />
								<pre-sel-one class="pre-input long1" @selectFunc="fun_list_menu($event)"
									v-bind:searchList="list_menu" :selectValue="sel_menu_val" />
							</div>
						</div>
						<div class="content_edit_item  tab-build">
							<div class="content_edit_item  ">
								<label>编辑模版:
								</label><input type="text" class="pre-input" v-model="sel_name" placeholder="必填" />
								<pre-sel-one class="pre-input long1 " @selectFunc="fun_list_selmode($event)"
									v-bind:searchList="list_mode" :selectValue="sel_mode_val" />
							</div>
						</div>
						<div class="content-edit-row">
							<div class="content_edit_item  ">
								<label>显示排序:</label><input class="pre-input short-word-2" type="number"
									v-model="menu_step" placeholder="" />
							</div>
						</div>
					</div>
					<div class="content_edit">
						<div class="content_edit_item">
							<button class="pre_btn_ok" @click="fun_menu_save()">发布</button>
						</div>
					</div>
				</div>
			</div>

		</div>

		<div id="pre_msg_data" style="display:none;"></div>
	</div>
</template>
<script>
	import api from '@/utils/type.js'
	import {
		GetShort,
		ChangeSpecial,
		BackSpecial
	} from '@/utils/localstore.js';
	import {
		Method_EasySelect,
		Method_Common,
		Method_CommonLong,
		Sel_page_and_length,
		Method_TableAll
	} from '@/utils/loadhttpdata.js';

	import {
		dateFormatToChina,
		dateFormatToChina2,
		dateFormatbyChina,
		daysFormMonth,
		checkStringByForm,
		Word_Right_Delete
	} from '@/utils/method.js'

	export default {
		components: {
			'pre-sel-one': () => import("../per_old/pre_select_one.vue")
		},
		data() {
			return {
				element_loading: false,
				activeName: 'first',
				show_note: false,

				show_push_1: true,
				show_push_2: false,
				show_push_3: false,
				show_push_4: false,

				sel_tab_name: '',
				sel_menu_name: '',
				sel_menu_name_d: '',

				row_id: '',
				sys_date: '',
				u_name: '',
				show_title: false,

				row_id_d: '',
				sys_date_d: '',
				u_name_d: '',
				show_title_d: false,

				tab_name: '', //表名
				sheet_val: '', //业务类型val,如果='',非业务表,否则初始化时默认新增字段 sheet_no
				sub_sheet_val: '', //父级业务参数

				edit_before: '', //前置检查
				edit_end: '', //后置检查

				menu_value: '', //页面跳转参数
				menu_name: '', //业务名称

				api_action: '', //命令选择 不需要填写，自动完成解析
				sel_action: '', //查询方法 默认标准方法(单表)。自定义方法(多表方法手动配置)
				upd_action: '', //编辑方法

				file_action: '', //文件方法 默认单文件，如果是多文件该如何处理
				isTwo: '', //主页是否隐藏两列，用于传递 文件链接
				path1: '', //
				path2: '', //
				path3: '', //

				note: '', //

				list_tab_main: [], //主业务建设
				list_tab_main_col: [], //主业务结构建设
				list_tab_detail: [], //子业务建设
				list_tab_detail_col: [], //自业务结构建设

				list_col: [], //字段类型
				sel_col_val: {},
				sel_col_id: '',
				sel_col_type: '',

				row_id_d: '',
				sys_date_d: '',
				tb_name: '', //字段结构名称
				td_name: '', //字段显示名称

				td_type: '', //字段类型
				td_sel_action: '', //如果下拉选项，还要配置查询方法
				td_default: '', //字段默认值

				td_sel: '0', //是否查询字段
				td_pass: '1', //是否编辑字段
				td_weight: '1', //是否必填关键字
				td_readonly: '0', //是否只读
				td_repeat: '1',
				td_step: 1, //字段顺序			待定

				td_x: 1, //字段显示x轴顺序
				td_class: '', //字段样式预设

				show_power: false,
				list_menu: [],
				sel_menu_val: {},
				sel_one_name: '',
				menu_step: 0,
				menu_id: 0,

				nowpage: 1,
				page_length: '20',
				maxpage: 0,
				jumppage: '',
				all_count: 0,

				list_mode: [],
				sel_name: '',
				sel_mode_val: {},
				mode_type: ''


			};
		},
		created: function() {

			this.fun_load_first();
			this.fun_load_menu();
		},
		mounted: function() {
			const that = this;
			// 滚动事件 scroll
			// 变形事件 resize
			window.addEventListener('scroll', function() {
				that.chang_style(); //fixed 行相对位置修正
			}, false);
			// 这里只是操作dom
			window.addEventListener('resize', function() {
				that.chang_style(); //fixed 行相对位置修正
			}, false);
		},
		watch: {
			user_id(val) {
				if (Number(val) > 0) {
					this.fun_load_push();
				}
			},
			row_id(val) {
				if (Number(val) > 0) {
					this.show_title = true;
				} else {
					this.show_title = false;
				}
			},
			row_id_d(val) {
				if (Number(val) > 0) {
					this.show_title_d = true;
				} else {
					this.show_title_d = false;
				}
			}

		},
		// computed: {
		// 	back_row_num: function(index) {
		// 		let row_num = 0;
		// 		row_num = (((this.nowpage - 1) * this.page_length) + index + 1);
		// 		return row_num;
		// 	}
		// },
		methods: {
			back_row_num: function(index) {
				let row_num = 0;
				row_num = (((this.nowpage - 1) * this.page_length) + index + 1);
				return row_num;
			},
			back_yes_no: function(flag) {
				let res = '是';
				if (Number(flag) == 0) {
					res = '否'
				}
				return res;
			},
			back_date: function(d) {

				return d.substring(0, 10);
			},
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			chang_style: function(t) {
				var that = this;
				this.$nextTick(function() {
					// var screenWidth = $(window).width();
					// var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
					// var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度
					// var row_width = 0;
					// if (t == '1') {
					// 	row_width = $('#second_title').width();
					// 	that.item_width = (row_width - 36 - 240) / 7;
					// }
					// if (t == '2') {
					// 	row_width = $('#third_content').width();
					// 	that.item_width = (row_width - 36 - 240) / 7;
					// }

					// console.log('行宽=' + row_width);

				});
			},

			handleClick(tab, event) {
				// console.log(tab, event);
				// console.log(tab.name);

				this.show_push_1 = false;
				this.show_push_2 = false;
				this.show_push_3 = false;
				this.show_push_4 = false;
				switch (tab.name) {
					case 'first':
						this.sheet_no = '';
						this.show_push_1 = true;
						this.fun_load_first();
						break;
					case 'second':
						this.show_push_2 = true;
						this.fun_load_second();
						this.fun_load_class('data_col_class', 'main_col');
						break;
					case 'third':
						this.show_push_3 = true;
						// this.check_alluser = false;
						// this.fun_load_dep_user();
						// this.chang_style('2');
						break;
					case 'fourth':
						this.show_push_4 = true;
						this.fun_load_class('data_col_class', 'main_col');
						break;
					default:
						this.show_push_2 = true;
						break;
				}
			},
			fun_load_first: function() {
				this.element_loading = true;
				this.fun_clear_data();

				if (Number(this.page_length) == 0) {
					this.page_length = 20;
				}

				let r = (Math.random() + '').substring(0, 8);
				this.list_tab_main = [];
				this.$post(
					api.http_method, Sel_page_and_length('base_tab_build', this.nowpage, this.page_length, '')
				).then(res => {
					res = JSON.parse(res);
					this.element_loading = false;
					// console.log(res);
					let res_page = [];
					res_page = res[0][0];
					// console.log(res_page);
					if (res_page.flag == 1) {
						this.nowpage = res_page.page_now;
						this.page_length = res_page.page_length;
						this.maxpage = res_page.all_page;
						this.all_count = res_page.all_count;
						let arr = res[1];
						// console.log(arr);
						// 修正返回结果
						// for (let i = 0; i < arr.length; i++) {
						// 	// console.log(arr[i])
						// 	for (let d in arr[i]) {
						// 		// console.log(d+'='+arr[i][d]);
						// 		if (d == 'edit_before') {
						// 			if (arr[i][d] == '1') {
						// 				arr[i][d] = '是';
						// 			} else {
						// 				arr[i][d] = '否';
						// 			}
						// 		}

						// 		if (d == 'edit_end') {
						// 			if (arr[i][d] == '1') {
						// 				arr[i][d] = '是';
						// 			} else {
						// 				arr[i][d] = '否';
						// 			}
						// 		}
						// 	}
						// }
						// console.log(arr);
						this.list_tab_main = arr;

					} else {
						this.$message({
							message: '出现问题! \r\n ' + '返回集合数量不对,请检查相应查询逻辑! ' + res_page.err,
							type: 'success'
						});
					}
					// this.comtype=res.data.data;
				});

			},
			beforepage: function() {
				if (Number(this.nowpage) > 1) {
					this.nowpage--;
					this.fun_load_first();
				} else {
					this.$message({
						message: '已经是第一页',
						type: 'warning'
					});
				}
			},
			nextpage: function() {
				if (Number(this.nowpage) < Number(this.maxpage)) {
					this.nowpage++;
					this.fun_load_first();
				} else {
					this.$message({
						message: '已经是最后一页',
						type: 'warning'
					});
				}
			},
			gopage: function() {

				if (Number(this.jumppage) > 0 && Number(this.jumppage) <= Number(this.maxpage)) {
					this.nowpage = this.jumppage;
					this.fun_load_first();
				} else {
					this.$message({
						message: '跳转页数不在规定范围内,请检查' + this.jumppage,
						type: 'warning'
					});
				}
			},
			fun_load_second: function() {
				this.list_tab_main_col = [];
				this.fun_clear_data_col();
				if (this.sel_tab_name == '') {
					this.$message({
						message: '请先选择主业务再编辑对应 参数结构!',
						type: 'warning'
					});
					return;
				}
				this.element_loading = true;
				// this.fun_clear_data();
				let r = (Math.random() + '').substring(0, 8);
				this.$post(
					api.http_method, Sel_page_and_length('struc_' + this.menu_value, 1, 99, '')
				).then(res => {
					res = JSON.parse(res);
					this.element_loading = false;
					console.log(res);

					let result = [];
					result = res[0][0];
					console.log(result);
					if (result.flag == 1) {
						this.list_tab_main_col = res[1];

						this.td_sel = '0';
						this.td_pass = '1';
						this.td_weight = '0';
						this.td_readonly = '0';
						this.td_repeat = '1';
						this.td_step = this.list_tab_main_col.length + 1;
						this.td_x = this.td_step;

					} else {
						this.$message({
							message: '出现问题! \r\n ' + '返回集合数量不对,请检查相应查询逻辑! ' + result.err,
							type: 'success'
						});
					}
				});
			},
			fun_clear_data: function() {
				this.sel_tab_name = '';
				this.sel_menu_name = '';

				this.row_id = '';
				this.sys_date = '';
				this.u_name = '';
				this.tab_name = ''; //表名
				this.sheet_val = ''; //业务类型val,如果='',非业务表,否则初始化时默认新增字段 sheet_no
				this.sub_sheet_val = ''; //父级业务参数

				this.menu_value = ''; //页面跳转参数
				this.menu_name = ''; //业务名称

				this.api_action = ''; //命令选择 不需要填写，自动完成解析
				this.sel_action = ''; //查询方法 默认标准方法(单表)。自定义方法(多表方法手动配置)
				this.upd_action = ''; //编辑方法

				this.file_action = ''; //文件方法 默认单文件，如果是多文件该如何处理
				this.isTwo = ''; //主页是否隐藏两列，用于传递 文件链接
				this.path1 = ''; //
				this.path2 = ''; //
				this.path3 = ''; //

				this.note = ''; //
			},
			sel_row_main: function(item, type) {
				// console.log(item);

				this.sel_tab_name = item.tab_name;
				this.sel_menu_name = item.menu_name;

				this.row_id = item.id;
				this.sys_date = item.sys_date;
				this.u_name = item.u_name;
				this.tab_name = item.tab_name; //表名
				this.sheet_val = item.sheet_val; //业务类型val,如果='',非业务表,否则初始化时默认新增字段 sheet_no
				this.sub_sheet_val = item.sub_sheet_val; //父级业务参数

				this.menu_value = item.menu_value; //页面跳转参数
				this.menu_name = item.menu_name; //业务名称

				this.api_action = item.api_action; //命令选择 不需要填写，自动完成解析
				this.sel_action = item.sel_action; //查询方法 默认标准方法(单表)。自定义方法(多表方法手动配置)
				this.upd_action = item.upd_action; //编辑方法

				this.edit_before = item.edit_before;
				this.edit_end = item.edit_end;

				this.file_action = item.file_action; //文件方法 默认单文件，如果是多文件该如何处理
				this.isTwo = item.isTwo; //主页是否隐藏两列，用于传递 文件链接
				this.path1 = item.path1; //
				this.path2 = item.path2; //
				this.path3 = item.path3; //

				this.note = item.note; //
				this.setCurrentRowJson(this.list_tab_main, type, item.id);
			},
			fun_build_save: function(type, tab_type) {

				if (type == '_upd') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (this.tab_name == '' || this.tab_name.length < 4) {
					this.$message({
						message: '表名不能为空并且长度小于4!',
						type: 'warning'
					});
					return;
				}

				if (!checkStringByForm(this.tab_name, 'Eng')) {
					this.$message({
						message: '表名只能由字母数字下划线构成并且由字母或下划线开始!',
						type: 'warning'
					});
					return;
				}

				if (!(this.menu_name.length >= 2 && this.menu_name.length < 20)) {
					this.$message({
						message: '业务名称必须是2至20个汉字!',
						type: 'warning'
					});
					return;
				}

				if (tab_type == '1') {
					if (this.sel_action.length == '' || this.upd_action == '') {
						this.$message({
							message: '查询方法和编辑方法都不能为空!',
							type: 'warning'
						});
						return;
					}
				}


				// console.log('提交======操作='+type+' 类型='+tab_type);

				this.element_loading = true;
				let d = [];
				d.push(this.tab_name);
				d.push(tab_type);
				d.push(this.row_id);
				d.push(this.sheet_val);
				d.push(this.sub_sheet_val);
				d.push(this.menu_value);
				d.push(this.menu_name);
				d.push(this.sel_action);
				d.push(this.upd_action);

				d.push(this.edit_before);
				d.push(this.edit_end);

				d.push(this.file_action);
				d.push(this.path1);
				d.push(this.path2);
				d.push(this.path3);
				d.push(this.note);

				let r = (Math.random() + '').substring(0, 8);

				this.$post(
					api.http_method, Method_CommonLong('_buildtab' + type, this.row_id, this.sys_date, d, r)
				).then(res => {
					res = JSON.parse(res);
					this.element_loading = false;
					// console.log(res);


					if (res.data.status == 1) {
						if (type == '_del') {
							this.fun_load_first();
						} else {
							this.sys_date = res.data.new_date;
						}

						this.$message({
							message: res.data.msg,
							type: 'success'
						});

					} else {
						this.$message({
							message: '出现问题! \r\n ' + res.data.msg,
							type: 'success'
						});
					}
					// this.comtype=res.data.data;
				});

			},
			fun_clear_data_col: function() {

				this.row_id_d = '';
				this.sys_date_d = '';
				this.tb_name = ''; //字段结构名称
				this.td_name = ''; //字段显示名称

				this.td_type = ''; //字段类型
				this.td_sel_action = ''; //如果下拉选项，还要配置查询方法
				this.td_default = ''; //字段默认值

				this.td_sel = '0'; //是否查询字段
				this.td_pass = '1'; //是否编辑字段
				this.td_weight = '0'; //是否必填关键字
				this.td_step = ''; //字段顺序			待定
				this.td_readonly = '0'; //
				this.td_repeat = '1';

				this.td_x = ''; //字段显示x轴顺序
				this.td_class = ''; //字段样式预设
			},
			sel_row_main_col: function(item, type) {
				// console.log(item);

				this.row_id_d = item.id;
				this.sys_date_d = item.sys_date;
				this.u_name_d = item.u_name;

				this.tb_name = item.tb_name; //字段结构名称
				this.td_name = item.td_name; //字段显示名称

				this.td_type = item.col_type; //字段类型
				console.log('类型=' + item.col_type);
				console.log(this.list_col);
				for (let d in this.list_col) {
					if (this.list_col[d].val == item.col_type) {
						this.sel_col_id = this.list_col[d].id;
						this.sel_col_type = this.list_col[d].type;
					}
				}

				this.td_sel_action = item.td_sel_action; //如果下拉选项，还要配置查询方法
				this.td_default = item.td_default; //字段默认值

				this.td_sel = item.td_sel; //是否查询字段
				this.td_pass = item.td_pass; //是否编辑字段
				this.td_weight = item.td_weight; //是否必填关键字
				this.td_step = item.td_step; //字段顺序			待定
				this.td_readonly = item.td_readonly;
				this.td_repeat = item.td_repeat;

				this.td_x = item.td_x; //字段显示x轴顺序
				this.td_class = item.td_class; //字段样式预设
				this.setCurrentRowJson(this.list_tab_main_col, type, item.id);
			},
			fun_col_save: function(type, tab_type) {

				if (type == '_upd') {
					if (this.row_id_d == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (this.tb_name == '' || this.tb_name.length > 30) {
					this.$message({
						message: '列名不能为空并且长度小于30!',
						type: 'warning'
					});
					return;
				}

				if (!checkStringByForm(this.tb_name, 'Eng')) {
					this.$message({
						message: '表名只能由字母数字下划线构成并且由字母或下划线开始!',
						type: 'warning'
					});
					return;
				}

				if (!(this.tb_name.length >= 2 && this.tb_name.length < 20)) {
					this.$message({
						message: '业务名称必须是2至20个汉字!',
						type: 'warning'
					});
					return;
				}

				if (this.sel_col_id == 0) {
					this.$message({
						message: '字段类型必须选择!',
						type: 'warning'
					});
					return;
				}

				if (this.sel_col_type == 'select' && this.sel_col_type == 'checkbox') {
					this.$message({
						message: '字段如果是多项选择，还要配置相应查询方法!',
						type: 'warning'
					});
					return;
				}


				console.log('提交======操作=' + type + ' 类型=' + tab_type);

				this.element_loading = true;
				let d = [];
				d.push(this.tab_name);
				d.push(tab_type);
				d.push(this.tb_name);
				d.push(this.td_name);
				d.push(this.sel_col_id);
				d.push(this.td_sel_action);
				d.push(this.td_default);
				d.push(this.td_sel);
				d.push(this.td_pass);
				d.push(this.td_weight);
				d.push(this.td_readonly);
				d.push(this.td_repeat);
				d.push(this.td_step);

				d.push(this.td_x);
				d.push(this.td_class);

				let r = (Math.random() + '').substring(0, 8);

				this.$post(
					api.http_method, Method_CommonLong('_buildcol' + type, this.row_id_d, this.sys_date_d, d, r)
				).then(res => {
					res = JSON.parse(res);
					this.element_loading = false;
					console.log(res);
					this.fun_load_second();
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});

					} else {
						this.$message({
							message: '出现问题! \r\n ' + res.data.msg,
							type: 'success'
						});
					}
					// this.comtype=res.data.data;
				});

			},
			setCurrentRowJson: function(tlist, key, id) {
				// console.log('key=' + key + ' id=' + id );
				for (var i = 0; i < tlist.length; i++) {
					if (tlist[i].id == id) {
						document.getElementById(key + id).style.background = '#92a4f3';
					} else {
						if (tlist[i].id % 2 == 0) {
							document.getElementById(key + tlist[i].id).style.background = '#fff';
						} else {
							document.getElementById(key + tlist[i].id).style.background = '#f5f5f5';
						}
					}
				}
			},
			fun_load_class: function(action, type) {
				let r = (Math.random() + '').substring(0, 8);
				this.list_col = [];
				this.$post(
					api.http_method, Method_EasySelect(action, r)
				).then(res => {
					res = JSON.parse(res);
					console.log(res);
					if (res.data.status == 1) {
						this.list_col = res.data.data;
					} else {
						this.$message({
							message: res.msg,
							type: 'success'
						});
					}

				});
			},
			fun_list_sel: function(e) {
				console.log(e);
				for (let d in this.list_col) {
					if (this.list_col[d].id == e) {
						this.td_type = this.list_col[d].val;
						this.sel_col_id = e;
						this.sel_col_type = this.list_col[d].type;
					}
				}
			},
			fun_load_menu: function() {
				this.list_menu = [];
				this.$post(
					api.http_method, Method_EasySelect('data_menu_one')
				).then(res => {
					res = JSON.parse(res);
					// console.log(res.data.data);
					if (res.data.status == 1) {

						for (var i = 0; i < res.data.data.length; i++) {
							var obj = {};
							obj.id = res.data.data[i].row_num;
							obj.rowid = res.data.data[i].id;
							obj.val = res.data.data[i].label;
							this.list_menu.push(obj);
						}
						// console.log(this.list_menu);

					} else {

						this.$message({
							message: res.data.message,
							type: 'warning'
						});

					}
				});
			},
			fun_show_power: function() {
				if (this.sel_tab_name == '') {
					this.$message({
						message: '请先选择主业务再发布到对应菜单!',
						type: 'warning'
					});
					return;
				}

				this.list_mode = [{
						"id": "1",
						"name": "弹窗模版",
						"val": "auto_build"
					},
					{
						"id": "2",
						"name": "简单模版",
						"val": "auto_easy"
					}
				];
				console.log(this.list_mode)

				this.show_power = true;
				var Hg = $(document).height();
				// 设置背景高度
				$(".pre_tan_bg").height(Hg);
				// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
				$(".pre_tan_bg").fadeIn("3000");
				$(".pre_tan_conten").fadeIn("3000");


			},
			closeshow: function() {
				$(".pre_tan_bg").fadeOut("3000");
				$(".pre_tan_conten").fadeOut("3000");

			},
			fun_list_menu: function(e) {
				// console.log(e);
				// console.log(this.list_menu);
				this.menu_id = 0;
				this.sel_one_name = '';
				for (let d in this.list_menu) {
					if (this.list_menu[d].id == e) {
						this.menu_id = this.list_menu[d].rowid;
						this.sel_one_name = this.list_menu[d].val;
					}
				}
			},
			fun_list_selmode: function(e) {
				console.log(e);
				for (let d in this.list_mode) {
					if (this.list_mode[d].id == e) {
						this.mode_type = this.list_mode[d].val;

						this.sel_name = this.list_mode[d].name;
					}
				}
			},
			fun_menu_save: function() {
				if (this.menu_id == 0) {
					this.$message({
						message: '请选择父级菜单!',
						type: 'warning'
					});
					return;
				}

				if (this.sel_tab_name.length > 8) {
					this.sel_tab_name = this.sel_tab_name.substring(0, 8);
				}

				let trans_data = '';
				console.log('一级菜单=' + this.menu_id + ' 菜单名称=' + this.sel_tab_name);
				// this.menu_value
				// 
				let parm = '';
				parm =
					'menu_id=' + Word_Right_Delete(this.menu_id) + '^' +
					'menu_no=' + Word_Right_Delete(this.menu_value) + '^' +
					'menu_name=' + Word_Right_Delete(this.sel_menu_name) + '^' +
					'menu_value=' + Word_Right_Delete(this.mode_type) + '^' +
					'page_no=' + Word_Right_Delete('') + '^' +
					'step=' + Word_Right_Delete(this.menu_step);
				console.log(parm);

				trans_data = Method_TableAll('_add', 'sheet_flag', 0, '', parm);

				this.$post(
					api.http_method, trans_data
				).then(res => {
					res = JSON.parse(res);
					console.log(res);
					this.$message({
						message: res.data.msg,
						type: 'success'
					});
				});

			}





		}
	};
</script>

<style scoped="scoped">
	.my_push {
		padding-left: 8px;
		padding-top: 2px;
	}

	.edit-main-tab {
		display: inline-flex;
		width: 100%;
		flex-direction: row;
		align-items: flex-start;
		flex-wrap: nowrap;
	}

	.push-1-left {
		display: inline-flex;
		flex-direction: column;
		align-items: flex-start;

	}

	.push-1-right {
		display: inline-flex;
		flex-direction: column;
		align-items: flex-start;
	}

	.push-1-right span {
		font-size: 14px;
		font-weight: 700;
		display: inline-block;
		margin-right: 10px;
		margin-left: 6px;
		line-height: 24px;
		height: 24px;
	}

	.push-2-left {
		display: inline-block;
		width: 722px;
		vertical-align: top;
		overflow: hidden;
	}

	.push-2-right {
		display: inline-block;
		width: calc(100% - 730px);
		vertical-align: top;
		overflow: hidden;
		margin-left: 2px;
	}

	.push-2-right span {
		font-size: 14px;
		font-weight: 700;
		display: inline-block;
		margin-right: 10px;
		margin-left: 6px;
		line-height: 24px;
		height: 24px;
	}

	.tab-inline {
		display: inline-block;
		vertical-align: top;
	}

	.tab-build-edit {
		min-height: 320px;

	}

	.tab-build input[type="text"] {
		color: #FF0000;
		font-weight: bold;
	}

	.td-build-textarea {
		display: inline-block;
		min-width: 600px;
		width: 80%;
		vertical-align: top;
	}

	.tab-item-btn {
		height: 32px;
		line-height: 32px;

	}


	.content-edit-row label {
		display: inline-block;
		min-width: 72px;
		vertical-align: -webkit-baseline-middle;
		text-align: right;
	}

	.content-edit-row .el-radio {
		.display: inline-block;
		vertical-align: bottom;
		margin-left: 2px;
	}

	label {
		min-width: 48px;
	}

	.pre_tan_conten {
		position: fixed;
		width: 28%;
		height: auto;
		left: 40%;
		top: 20%;
		/* background: #faf5f5; */
		background-color: azure;
		border-radius: 5px;
		max-height: 80%;
		z-index: 30;
		overflow-y: auto;
		overflow-x: hidden;

	}

	.col-type {

		overflow: hidden;
		max-width: 68px;
	}

	.col-type a {
		text-decoration: none;
		position: relative;
		display: block;
	}

	.col-type a span {
		font-size: 12px;
		display: none;
	}


	.col-type a:hover span {
		cursor: pointer;
		position: fixed;
		display: flex;
		padding: 1px 4px;
		background: #00aaff;
		color: #fff;
		font-size: 12px;
		border-width: 1px 2px 2px 1px;
		border-color: #333;
		border-style: solid;
		border-radius: 5px;
		height: 26px;
		line-height: 26px;
		/* top: 10px;
    left: 2px; */
		z-index: 999999;

		margin-top: -28px;
		margin-left: 60px;
	}


	.pre-input {
		display: inline-block;
		vertical-align: middle;
		width: 128px;
	}
</style>
